import React from 'react';
import CommandItem from './CommandItem';
import { useCommandHandlers } from './CommandHandlers';
import { useTranslation } from 'react-i18next';

function CommandList({ commandItems, onCommandChange, onAddCommand }) {
  const { handleInputChange, handleClear, handleAdd } = useCommandHandlers(onCommandChange, onAddCommand);
  const { t } = useTranslation();
  return (
        <table>
          <caption>{t('command_list_title')}</caption>
          <tbody>
            {commandItems.map(item => (
              <CommandItem
                key={item.command}
                command={item.command}
                value={item.value}
                description={item.description}
                type={item.type}
                onInputChange={handleInputChange}
                onClear={handleClear}
                onAdd={handleAdd}
                readonly={item.readonly}
                placeholder={item.placeholder}
              />
            ))}
          </tbody>
        </table>
  );
}

export default CommandList;